import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[appVar]',
    exportAs: 'appVar',
    standalone: false
})
export class VarDirective {
  @Input() var: any;
}
